module.exports = __webpack_public_path__ + "img/arrow-down-icon.c32ab61b.svg";